import { pipe, prop } from 'ramda';
import type { RootState } from 'src/reducers/root';

const selectAllBlogState = (state: RootState) => state.blog;

export const selectCurrentPage = pipe(selectAllBlogState, prop('currentPage'));

export const selectIsInitialFetchDone = pipe(
  selectAllBlogState,
  prop('isInitialFetchDone')
);

export const selectIsLoading = pipe(selectAllBlogState, prop('isLoading'));

export const selectPosts = pipe(selectAllBlogState, prop('posts'));

export const selectHasMore = pipe(selectAllBlogState, prop('hasMore'));
